import { render } from "./FormCount.vue?vue&type=template&id=2463beba&scoped=true&ts=true"
import script from "./FormCount.vue?vue&type=script&lang=ts"
export * from "./FormCount.vue?vue&type=script&lang=ts"

import "./FormCount.vue?vue&type=style&index=0&id=2463beba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2463beba"]])

export default __exports__